import type { Account as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * An account as a *picker* renders it: an id and a label, nothing else.
 *
 * That makes three account-ish types in this directory, so here is which is which. `Account.ts`
 * maps the schema-wide `AccountSummary` — a different GraphQL type that happens to have the same
 * shape, resolved by the staff `orders` and `customers` reads. `Client.ts` is the full
 * administration record the superadmin account screens read and write. This one exists because the
 * account switcher is a type-ahead: it re-reads on every debounced keystroke, and going through
 * `Client` would mean `INTERNAL_ACCOUNT_LIST_FIELDS` dragging `feeStructure` and `owner` along each
 * time for two scalars nothing renders.
 */
export type AccountOption = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): AccountOption =>
  take<AccountOption>(item, 'id', 'name');

export const fromGqlCollection = (items: GQLItem[]): AccountOption[] => items.map(fromGql);
